import { ComboboxOption } from "@headlessui/react";
import { ComboBoxOption } from "./Input";

export type MathComparisonSymbol = "=" | "!=" | "<=" | ">=" | "<" | ">";
export const MATH_COMPARISON_SYMBOLS: ComboBoxOption<MathComparisonSymbol>[] = [
    { label: '=', value: '=' },
    { label: '!=', value: '!=' },
    { label: '<=', value: '<=' },
    { label: '>=', value: '>=' },
    { label: '<', value: '<' },
    { label: '>', value: '>' }
];

export const MATH_STRING_SIGNS: ComboBoxOption<MathComparisonSymbol>[] = [
    { label: '=', value: '=' },
    { label: '!=', value: '!=' }
];

export const MATH_OPERATORS = ["and", "or"] as const;
export type MathOperator = typeof MATH_OPERATORS[number];

export const MATH_OPERATOR_OPTIONS: ComboBoxOption<MathOperator>[] = [
    { label: "OR", value: "or" },
    { label: "AND", value: "and" }
]